module.exports = __webpack_public_path__ + "img/img30.94ab1848.png";